"use client";

import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import React from "react";
import { useBreakpoint } from "../../../shared/utils/hooks/useBreakpoint";
import clsx from "clsx";

const images = [
  "/assets/scroll/img1.jpg",
  "/assets/scroll/img2.jpg",
  "/assets/scroll/img3.jpg",
  "/assets/scroll/img4.jpg",
  "/assets/scroll/img5.jpg",
];

const positions = [
  {
    tops: "27%",
    top: "20%",
    center: true,
    z: 10,
    ws: "18.75rem",
    wm: "37.3125rem",
    wl: "60rem",
  },
  {
    tops: "14%",
    top: "7%",
    right: "0%",
    z: 20,
    ws: "17.375rem",
    wm: "31.125rem",
    wl: "50rem",
  },
  {
    tops: "38%",
    top: "14%",
    left: "1%",
    z: 30,
    ws: "15.5rem",
    wm: "24.875rem",
    wl: "33.75rem",
  },
  {
    tops: "48%",
    top: "24%",
    center: true,
    z: 40,
    ws: "16.9375rem",
    wm: "27.9375rem",
    wl: "45rem",
  },
  {
    tops: "69%",
    top: "48%",
    right: "3%",
    z: 50,
    ws: "14.25rem",
    wm: "21.75rem",
    wl: "35rem",
  },
];

export default function ImageSection() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [scrollY, setScrollY] = useState(0);
  const sectionHeightRef = useRef(0);
  const { mobileMode, desktopMode } = useBreakpoint();

  useEffect(() => {
    const handleResize = () => {
      // setSectionHeight(1080 * 2);
      // let height = mobileMode ? 600 : window.innerHeight;
      sectionHeightRef.current = window.innerHeight * images.length;
    };

    const handleScroll = () => {
      if (window.scrollY < sectionHeightRef.current) setScrollY(window.scrollY);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section
      className="relative w-full bg-white px-[0.5rem] sm:px-[4rem] lg:px-[6rem] xl:px-[10rem]"
      style={{ height: `${sectionHeightRef.current * 1.2}px` }}
    >
      <div
        ref={containerRef}
        className={clsx(
          "sticky top-2 h-[40rem] flex items-center justify-center overflow-visible",
          "sm:top-14 sm:h-[52.125rem] ",
          "lg:top-24 lg:h-screen"
        )}
      >
        <div className="relative w-full h-full">
          {images.map((src, index) => {
            const triggerPoint = window.innerHeight * index * 0.9;
            const distance = window.innerHeight * 0.9;
            const progress = Math.min(
              Math.max((scrollY - triggerPoint) / distance, 0),
              1
            );
            const baseY = 150; // 아래에서 올라오는 정도

            const style: React.CSSProperties = {
              opacity: progress,
              top: mobileMode ? positions[index].tops : positions[index].top,
              zIndex: positions[index].z,
              width: desktopMode
                ? positions[index].wl
                : mobileMode
                ? positions[index].ws
                : positions[index].wm,
              transition: `${
                mobileMode
                  ? "opacity 0.4s ease-out"
                  : "opacity 0.4s ease-out, transform 0.4s ease-out"
              }`,
            };

            if (positions[index].center) {
              style.left = "50%";
              // style.transform = `translate(-50%)`;
              style.transform = `translate(-50%, ${baseY * (1 - progress)}px)`;
            } else if (positions[index].right) {
              style.right = positions[index].right;
              style.transform = `translateY(${baseY * (1 - progress)}px)`;
            } else {
              style.left = positions[index].left;
              style.transform = `translateY(${baseY * (1 - progress)}px)`;
            }

            return (
              <motion.img
                key={index}
                src={src}
                alt="stacked-img"
                className="absolute object-cover shadow-xl"
                style={style}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}
